// Texte der Bibliothek selbst (Platzhalter, Sortierung), Sprache wie die Kunden-Apps. reference: [1]
import {createT} from './i18n.js';

const trans = {
    de: {
        'Sort by': 'Sortieren nach',
        'Select an option...': 'Bitte wählen …',
    },
    pl: {
        'Sort by': 'Sortuj według',
        'Select an option...': 'Wybierz …',
    },
};

const t = createT(trans);

export {t};
